var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_7573_4296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.6 13.2626C9.2 13.3626 9 13.7626 9 14.1626C9 14.6626 9.4 15.1626 10 15.1626C10.6 15.1626 11 14.7626 11 14.1626C11 13.3626 10.2 12.9626 9.6 13.2626Z",
    fill: "#F1585E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 5.1626C9.4 5.1626 9 5.5626 9 6.1626V11.1626C9 11.7626 9.4 12.1626 10 12.1626C10.6 12.1626 11 11.7626 11 11.1626V6.1626C11 5.5626 10.6 5.1626 10 5.1626Z",
    fill: "#F1585E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 0.162598C4.5 0.162598 0 4.6626 0 10.1626C0 15.6626 4.5 20.1626 10 20.1626C15.5 20.1626 20 15.6626 20 10.1626C20 4.6626 15.5 0.162598 10 0.162598ZM10 18.1626C5.6 18.1626 2 14.5626 2 10.1626C2 5.7626 5.6 2.1626 10 2.1626C14.4 2.1626 18 5.7626 18 10.1626C18 14.5626 14.4 18.1626 10 18.1626Z",
    fill: "#F1585E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7573_4296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.162598)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WarningIcon.db5a4e6a.svg";
export { ForwardRef as ReactComponent };